import { useState, useEffect } from "react";

import { COMPANY_ID } from "../constants";
import initEvidon from "../helpers/initEvidon";

const useEvidonLib = () => {
  const [isEvidonLibReady, setIsEvidonLibReady] = useState(false);

  useEffect(() => {
    initEvidon({ id: COMPANY_ID }).then(() => {
      setIsEvidonLibReady(true);
    });
  }, []);

  return isEvidonLibReady;
};

export default useEvidonLib;
